var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.2 462.6H33.6V164.4c0-10.4-7.5-18.6-16.8-18.6C7.4 145.8 0 154 0 164.4v317C0 491.8 7.4 500 16.8 500h466.4c9.4 0 16.8-8.2 16.8-18.6 0-10.3-7.7-18.8-16.8-18.8zM16.8 102.5c9.3 0 16.8-8.2 16.8-18.6V18.6C33.6 8.2 26 0 16.8 0 7.4 0 0 8.2 0 18.6v65.3c0 10.1 7.4 18.6 16.8 18.6zM375 230.1c4.6 0 9.4-2 13-6.1l71.7-79.4c7-7.8 7-21 0-28.8-7.1-7.8-19-7.8-26 0L362 195.2c-7 7.8-7 21 0 28.8 3.5 4 8.2 6.1 13 6.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 338.7c4.7 0 9.5-2 13.2-6.1l89.2-99 70.4 78a21 21 0 0 0 13.2 6.2c5 0 9.4-2.4 13.1-6.2l30-33.7c7-7.9 7-21 0-28.8-7.2-7.9-19-7.9-26 0l-17.1 19.2-70.7-77.7c-7.3-8.1-18.9-8.1-26 0L95.4 304.1c-7.1 7.8-7.1 21 0 28.8 3.7 3.8 8.4 5.8 13.1 5.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.5fe2aa74.svg";
export { ForwardRef as ReactComponent };